import React from "react"
import styled from "styled-components"

import {
  H1,
  H2,
  P,
  Input,
  NextStep,
  PrevNextStep,
} from "../general/GeneralStyles"
import axios from "axios"

const FormGrid = styled.div`
  width: 95%;
  max-width: 550px;

  ${P} {
    margin-bottom: 0px;
    margin-left: 30px;
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;

    ${Input} {
      width: 30%;
      margin-bottom: 0;

      &:not(:nth-child(1)) {
        margin-left: auto;
      }
    }

    span {
      display: block;
      margin-left: 32px;
      color: ${props => props.theme.primaryTextColor};
      font-family: ${props => props.theme.primaryFont};
      font-size: 12px;
      line-height: 28px;
    }
  }
`

const Step1 = props => {
  const setFormData = e => {
    props.setFormData({ ...props.formData, [e.target.name]: e.target.value })
  }

  const inputValidation = () => {
    console.log("step 1 props.formData: " + props.formData)
    if (
      !props.formData.home_street1 ||
      // !props.formData.street_address2 ||
      !props.formData.home_zip
    ) {
      alert("Please fill all the fields to continue")
    } else {
      props.setStep(2)
    }
  }

  return (
    <>
      <H1>Sign Up</H1>
      <H2>
        <span>Step 1:</span> Let's Find Your Home Address
      </H2>
      <FormGrid>
        <Input
          type="text"
          placeholder="Street Address 1"
          name="home_street1"
          value={props.formData.home_street1}
          onChange={props.inputHandler}
          required
        />
        <Input
          type="text"
          placeholder="Street Address 2"
          name="home_street2"
          value={props.formData.home_street2}
          onChange={props.inputHandler}
        />
        <div>
          <Input
            type="text"
            placeholder="Zip Code"
            name="home_zip"
            value={props.formData.home_zip}
            onChange={props.inputHandler}
            required
          />
          <P>
            {props.formData.city || ""}, {props.formData.state || ""}
          </P>
        </div>
        <PrevNextStep>
          <NextStep href="#" onClick={inputValidation}>
            Next Step
          </NextStep>
        </PrevNextStep>
      </FormGrid>
    </>
  )
}

export default Step1
